import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Ministry} from './ministry.model';

export const loadMinistrys = createAction(
  '[Ministry/API] Load Ministrys',
  props<{ ministrys: Ministry[] }>()
);

export const addMinistry = createAction(
  '[Ministry/API] Add Ministry',
  props<{ ministry: Ministry }>()
);

export const upsertMinistry = createAction(
  '[Ministry/API] Upsert Ministry',
  props<{ ministry: Ministry }>()
);

export const addMinistrys = createAction(
  '[Ministry/API] Add Ministrys',
  props<{ ministrys: Ministry[] }>()
);

export const upsertMinistrys = createAction(
  '[Ministry/API] Upsert Ministrys',
  props<{ ministrys: Ministry[] }>()
);

export const updateMinistry = createAction(
  '[Ministry/API] Update Ministry',
  props<{ ministry: Update<Ministry> }>()
);

export const updateMinistrys = createAction(
  '[Ministry/API] Update Ministrys',
  props<{ ministrys: Update<Ministry>[] }>()
);

export const deleteMinistry = createAction(
  '[Ministry/API] Delete Ministry',
  props<{ id: string }>()
);

export const deleteMinistrys = createAction(
  '[Ministry/API] Delete Ministrys',
  props<{ ids: string[] }>()
);

export const clearMinistrys = createAction(
  '[Ministry/API] Clear Ministrys'
);

// CUSTOM ACTIONS
export const createInstitutionMinistryMutation = createAction(
  '[Ministry/API] Create Ministry',
  props<{ input: any }>()
);

export const updateInstitutionMinistryMutation = createAction(
  '[Ministry/API] update Institution Ministry Mutation',
  props<{ input: any }>()
);

export const getAllMinistries = createAction(
  '[Ministry/API] Get all Ministrys',
  props<{ filtering?: {uniqueId?:string} }>()
);


export const getUserApprovalRosterMinistries = createAction(
  '[Ministry/API] Get User Approval Roster Ministries',
  props<{ filtering?: {uniqueId?:string} }>()
);

